<section class="ftco-section p-5 d-flex flex-column">
    <a href="/"><img [src]="logo" alt="logo" style="width: 100px;"/></a>
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
        <div class="text-center p-5 m-5 w-50 d-none d-md-block">
            <h4>Study</h4>
            <h4  [style]="style.color">Practice</h4>
            <h4>Succeed</h4>
        </div>
        <div class="w-100 w-md-50 row">
            <div class="col-md-3"></div>
            <div class="bg-light m-5 p-5 mx-auto rounded col-md-6">
                <h5 class="mb-4">Reset Password</h5>
    
                <form [formGroup]="resetForm" class="signin-form">
                    <div class="form-group mb-3">
                        <label class="label" for="resetpassword">New Password</label>
                        <input type="password" class="form-control" placeholder="New Password" formControlName="password" required>
                    </div>
                    <div class="form-group mb-3">
                        <label class="label" for="confirmpassword">Confirm Password</label>
                        <input type="password" class="form-control" placeholder="Confirm Password" formControlName="passwordII" required>
                    </div>
                    <div *ngIf="resetForm.hasError('passwordMismatch')" class="text-danger text-center">
                        Passwords do not match.
                      </div>
                    <div class="form-group">
                        <button type="submit" [style]="style.btnstyle" (click)="resetPassword()" [disabled]="resetForm.invalid" class="w-100 submit px-3 mt-5" >Reset Password</button>
                    </div>
                </form>
            </div>
            <div class="col-md-3"></div>
        </div>        
    </div>
</section>